// 总交易报表
import request from '@/utils/request'

export function page(data) {
  return request({
    url: '/mg/daohang-report-api/retailSaleOrderSummary/querySummary',
    method: 'post',
    data,
  })
}

export function pageExport(data) {
  return request({
    url: '/mg/daohang-report-api/retailSaleOrderSummary/exportSummaryExcel',
    method: 'post',
    data,
    responseType: 'blob',
  })
}

export function pageSummary(data) {
  return request({
    url: '/mg/daohang-report-api/retailSaleOrderSummary/sum',
    method: 'post',
    data,
  })
}
